import React, { Component } from "react";
import "./Branch.css";
import { Label, ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,Well} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import HeatMap from "react-heatmap-grid"
import ReactMarkdown from 'react-markdown/with-html'
function sort_name(a,b){
    if(a.name < b.name) { return -1; }
       if(a.name > b.name) { return 1; }
       return 0;
}

function online(d){
  let last_seen=new Date(d.last_seen)
  if(d.online===1)
    return (<Label className="pull-right" title={"Last msg:"+last_seen.toLocaleString()}>Online</Label>)

  return

}



function TempColours(props){

  var colour="#000000"

  if(props.data.state <-25){
    colour="#0006ff"
  }else if(props.data.state <0){
      colour="#0059ff"
  }
  else if(props.data.state <10){
      colour="#00abff"
  }
  else if(props.data.state <20){
      colour="#ffd600"
  }

  else if(props.data.state >=20){
      colour="#ff8300"
  }





  var temperature_style={"color":colour}


  return <span style={temperature_style} >{props.data.state}&nbsp;°C</span>



}



function TempGrid(props){
  console.log(props.data)

  let d=props.data
  if(d.type==512){
  let momenttime=(<Moment fromNow>{new Date(d.last*1000-2000)}</Moment>)
  if(props.detail==false){
    return (<div className="lowDetailTemp" title={"Last:"+new Date(d.last*1000-2000)}><center>
              <h2 className="simpleTempReading"><TempColours data={d} /></h2>
              <b className="temperature_title_oneline"> {d.name}</b><br/>
              <i>12h:{d.avg12h}&nbsp;°C</i>
              </center>
            </div>)
  }
  else{
      return (<p className="temperature ">
            <div className="temperature_name">
                <span><b>{d.name}</b></span>
                <b className="temperature_detail"><TempColours data={d} /></b>
            </div>


                <span title={new Date(d.last*1000)}>{momenttime}</span>
                <br/>
                <i>12h:{d.avg12h}&nbsp;°C</i>
              </p>)
      }
}

  return ""
}


function AltiomGrid(props){
  console.log(props.data)
  let d=props.data
  return (<p className="item" title={d.IP+" / "+d.altid}>
        <a href={"/a/"+d.altid}><b>{d.UNIT}</b>:<span>{d.ROOM}</span></a>
    <br/>{online(d)}
        </p>)
}



function EventCount(props){
  //console.log(props.data)
  let d=props.data
  let callback=props.callback
let xLabels=new Array(props.heat.data.length)
//  console.log("xLab")
 xLabels=["","","","3AM","","","6AM","","","9AM","","","12AM","","","3PM","","","6PM","","","9PM","",""]
  //console.log(xLabels)
  let hdata=[props.heat.data]
  if(props.heat.data.length==0){
    return("")
  }

//  if(hdata[0].length!=24){
  //  hdata[0]=datapad(hdata[0],24)
  //}
  let xLabelsShow=[false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]
  let yLabels=[1]

  let temp=(<div className="eventSum"></div>)



  return (<div className="eventSum heatMap">



  {d.key=="0"?(
  <HeatMap className={d.doc_count} xLabels={xLabels} yLabels={["None"]} data={hdata} onClick={(x,y,e,v)=>callback(x,y,d.key,"event") } cellStyle={(background, value, min, max, data, x, y) => ({
      background: `rgba(159, 159, 159, ${1 - (max - value) / (max - min)})`,
      fontSize: "11px",
    })} />):("")}

  {d.key=="1"?(
  <HeatMap xLabels={xLabels} yLabels={["Green"]} data={hdata} xLabelsVisibility={xLabelsShow} onClick={(x,y,e,v)=>callback(x,y,d.key,"event")} cellStyle={(background, value, min, max, data, x, y) => ({
    background: `rgba(50, 255, 85, ${1 - (max - value) / (max - min)})`,
    fontSize: "11px",
  })} />):("")}

  {d.key=="2"?(
  <HeatMap xLabels={xLabels} yLabels={["Amber"]} data={hdata}  xLabelsVisibility={xLabelsShow}  onClick={(x,y,e,v)=>callback(x,y,d.key,"event")} cellStyle={(background, value, min, max, data, x, y) => ({
    background: `rgba(255,173, 50, ${1 - (max - value) / (max - min)})`,
    fontSize: "11px",
  })} />):("")}

  {d.key=="3"?(
  <HeatMap xLabels={xLabels} yLabels={["Red"]} data={hdata}  xLabelsVisibility={xLabelsShow} onClick={(x,y,e,v)=>callback(x,y,d.key,"event")} cellStyle={(background, value, min, max, data, x, y) => ({
    background: `rgba(255, 50, 50, ${1 - (max - value) / (max - min)})`,
    fontSize: "11px",
  })} />):("")}



  </div>)
}

export default class BranchTemperature extends Component {
    constructor(props) {
      super(props);
      this.state = {
        md_auth:null,
        md_unauth:null,
        name:"",
        isLoading:true,
        data:[],
        timestring:"Today",
        temp:[],
        eventslevels:[],
        day:0,
        raw:[],
        rawLoading:true,
        tempdetail:false
      };
    }
    changeview(){

      this.setState({tempdetail:!this.state.tempdetail})


    }
    today(){
      let time=new Date()
      time.setHours(0)
      time.setMinutes(0)
      time.setSeconds(0)
      time.setMilliseconds(0)
      return time.getTime()
    }

    forward(){
      console.log("Forward")
      let day=this.state.day
      day=day+1
      this.setState({day:day})
      this.getDayData(day)
    }

    backward(){
      console.log("Backward")
      let day=this.state.day
      day=day-1
      this.setState({day:day})
      this.getDayData(day)
    }

    async getDayData(day){
      let time=this.today()
      time=time+(24*3600000*day)
      console.log("Get Day Data"+day)




      let datetime=new Date(time)
      if(day==-1){
        this.setState({timestring:"Yesterday "+datetime.toLocaleDateString()})
      }
      else if(day>0){
        this.setState({timestring:"Future! "+datetime.toLocaleDateString()})
      }
      else if (day==0) {
        this.setState({timestring:"Today"})
      }
      else{
          this.setState({timestring:datetime.toLocaleDateString()})

      }

      const data = await this.getdata(time,"Temperature");
      console.log(data)
      this.setState(data)
    }

    callback=async(x,y,type,e)=>{
      let time=this.today()
      console.log(time)
      time=time+24*3600000*this.state.day
      time=time+x*3600000

      console.log("Get Raw Data")
      this.setState({indepth:false})
      this.setState({indepthTitle:new Date(time).toLocaleDateString() +" @ "+new Date(time).toLocaleTimeString()})
      //For events do a timeline of the event with colourisation and description.
      console.log(time)
      console.log(type)
      this.setState({"rawLoading":true})
      var data = await this.getdata(time,"rawevents",type);
      //for the inputs can i do a small chart with details?
      var ldata=data.detail
      var temp=[]
      console.log(data)
      for(var i=0;i<ldata.hits.length;i++){
        console.log(ldata.hits[i]["_source"])
        ldata.hits[i]["_source"]["altname"]=this.nameFromAltid(ldata.hits[i]["_source"]["altid"])
        temp.push(ldata.hits[i]["_source"])
      }
      this.setState({"raw":temp})
      this.setState({"rawLoading":false})


    }



    async componentWillMount() {
      const data = await this.getdata(this.today(),"Temperature");
      console.log(data)
      data["eventslevels"]=[{"key":"0","doc_count":0},{"key":"1","doc_count":0},{"key":"2","doc_count":0},{"key":"3","doc_count":0}]
      this.setState({isLoading:false})
      this.setState(data)
    }




    getdata(t, mode="",sensor="",altid="") {

      var data = {
        'queryStringParameters': {
            branch:this.props.match.params.id,
            time:t,
            mode:mode,
            sensor:sensor,
            altid:altid
        }
      }


      return API.get("AltiomData", "/altiom",data);
    }
    nameFromAltid(altid){

      let altioms=this.state.data
      if("altids" in this){
            return this.altids[altid]
      }
      else{

        let altids={}
        for(let i=0;i<altioms.length;i++){
          altids[altioms[i]["_id"]]=altioms[i]["_source"]["UNIT"]+" "+altioms[i]["_source"]["ROOM"]
        }
        this.altids=altids
        return this.altids[altid]
      }


    }


    online(data){
      console.log(data)
      if(data===1)
        return (<span className="green">Online</span>)
      if(data===0)
        return (<span className="red" >Offline</span>)

    }
    logitem(data,index){
      let type="Unknown"
      let message=""
    //  console.log("LOG ITEM "+index)
      let altname=""
      if("altname" in data){
        altname=data.altname
      }
      switch(data.type){
        case 0xA0000:
          return ""

        case 0xA0001:
            message=(<span><b>Input:</b>{data.name}:{data.state_text}</span>)
            break;
        case 0xA0002:
            let levels=["None" ,"Green","Amber", "Red"]
            let label=(<Label className={"alert"+levels[data.level]}>{levels[data.level]}</Label>)
            if(data.state==1){
              if(data.name=="Temperature Alert"){
                  message=<span><b>Event:</b>{data.name} <b>True</b> {label}<p>{data.Description}</p></span>
              }
              else{
                message=(<span><b>Event:</b>{data.name} <b>True</b> {label}</span>)
              }
            }
            if(data.state==0){
              if(data.name=="Temperature Alert"){
                  message=<span><b>Event:</b>{data.name} <b>False</b> {label}<p>{data.Description}</p></span>
              }
              else{
              message=(<span><b>Event:</b>{data.name} <b>False</b> {label}</span>)
              }
            }
            break;
        case 0xA0003:
            type="Var Data"
            if(data.value==0)
              message=(<Label>SAFE MODE OFF</Label>)
            else
              message=(<Label>SAFE MODE ON</Label>)
            break;
      }
      var time=new Date(data.time)


      return (<p key={index}title={JSON.stringify(data)} ><small>{time.toLocaleTimeString()}</small>&nbsp;{altname} {message}</p>)

    }

    render() {
      return (
          <div className="Home">
          <Jumbotron>
          <Button className="pull-right" onClick={()=>this.props.history.goBack()}>Back</Button>
            {this.state.isLoading ? (<h2>Loading...</h2>):(

              <div>
              <h2>Temperatures at {this.state.name}</h2>
              <br/>
              <Button onClick={()=>this.changeview()}>{this.state.tempdetail? (<span>View Simplified</span>):(<span>View Detailed</span>)}</Button>
              <br/>
              <br/>
              {/*sort((a,b)=>sort_name(a,b))*/}
              <Well>
              <div className="flex-grid">
              {this.state.temp.map((l,i)=><TempGrid key={"temp"+i} data={l} detail={this.state.tempdetail}>Sensor</TempGrid>)}
              </div>
              </Well>
              <br/>
              <h3>Events <span>({this.state.timestring})</span>
              <span className="pull-right">
                <Button  onClick={()=>this.backward()}><i className="fa fa-chevron-left"></i></Button>
                <Button  onClick={()=>this.reset()}>Today</Button>
                <Button  onClick={()=>this.forward()}><i className="fa fa-chevron-right"></i></Button>
              </span>
              </h3>
              <br/>
              {this.state.eventslevels.map((l,i)=><EventCount key={"eventHeat"+l.key} data={l} heat={this.state.events[l.key]} callback={this.callback}>{l.key}:{l.doc_count}</EventCount>)}

              <hr/>
              {this.state.rawLoading==false ? (
                <div>
                <hr/>
                  <h3>Logs (1h)</h3><span>{this.state.indepthTitle}</span>
                  <Well>
                  {this.state.raw.map(
                    (d, i) =>
                          <span key={i}>
                          {this.logitem(d,i)}
                          </span>
                  )}
                  </Well>
                </div>
              ):("")}

              <h3>Devices at {this.state.name}</h3>
              <div className="flex-grid">
              {this.state.data.map((l,i)=><AltiomGrid className="item" key={i} data={l._source}>ALTIOM</AltiomGrid>)}
              </div>
              </div>
)
            }
            </Jumbotron>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/BranchTemperature.js